export enum FinalStepsFormField {
  FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION = 'final-steps/pending-required-documentation',
  FINAL_STEPS_INTERNAL_NOTES = 'final-steps/internal-notes'
}
